export default __webpack_public_path__ + "static/media/6_bottom.db440ea2.png";